import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        classifiers: '=',
        defaultFilter: '=',
        filter: '=',
        hasActiveUsers: '=',
        showFilter: '=',
        sites: '='
    },
    template: `
        <div class="table-filters" ng-model="vm.ngModel">
            <form ng-submit="vm.applyFilter()" class="form form-filter" ng-if="vm.showFilter==true">
                <div class="fields">
                    <div class="row row-md">
                        <label class="label">{{ 'filter.Name' | translate }}</label>
                        <div class="items"><input ng-model="vm.filter.name" type="text" class="form-control"></div>
                    </div>
                    <div class="row row-md">
                        <label class="label">{{ 'filter.Email' | translate }}</label>
                        <div class="items"><input ng-model="vm.filter.primaryEmail" type="text" class="form-control"></div>
                    </div>
                    <div class="row separated">
                        <label class="label">{{ 'filter.Site' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.sites.options"
                                selected-model="vm.multiFilter.sites.model"
                                extra-settings="vm.multiFilter.sites.settings"
                                ng-click="vm.updateEmployees()"
                                translation-texts="vm.filterTranslations"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row row-md">
                        <label class="label">{{ 'filter.Department' | translate }}</label>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                options="vm.FilterService.departmentSelect.options"
                                selected-model="vm.FilterService.departmentSelect.models"
                                extra-settings="vm.FilterService.departmentSelect.settings"
                                events="vm.FilterService.departmentSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Role' | translate }}</label>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                options="vm.FilterService.roleSelect.options"
                                selected-model="vm.FilterService.roleSelect.models"
                                extra-settings="vm.FilterService.roleSelect.settings"
                                events="vm.FilterService.roleSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Level' | translate }}</label>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                options="vm.FilterService.levelSelect.options"
                                selected-model="vm.FilterService.levelSelect.models"
                                extra-settings="vm.FilterService.levelSelect.settings"
                                events="vm.FilterService.levelSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </div>
                    <div class="row row-md">
                        <label class="label">{{ 'filter.Direct manager' | translate }}</label>
                        <div class="items">
                            <autocomplete
                                label-attribute="'displayName'"
                                selected-item="vm.selectedEmployee"
                                ng-model="vm.filter.directManagerId"
                                value-attribute="'id'"
                                query="vm.queryUsers(input)"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'filter.Employment status' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.statuses.options"
                                selected-model="vm.multiFilter.statuses.model"
                                extra-settings="vm.multiFilter.statuses.settings"
                                translation-texts="vm.filterTranslations">
                            </div>
                        </div>
                    </div>
                    <div class="row row-md">
                        <label class="label">{{ 'filter.Account activated' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.activeStatusList.options"
                                selected-model="vm.multiFilter.activeStatusList.model"
                                extra-settings="vm.multiFilter.activeStatusList.settings"
                                translation-texts="vm.filterTranslations"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <span class="label">{{ 'filter.Only direct managers' | translate }}</span>
                        <div class="items">
                            <label class="switch01">
                                <input name="switch" type="checkbox" ng-model="vm.filterDirectManagersOnly">
                                <span>{{ 'general.Yes' | translate }}</span>
                            </label>
                        </div>
                    </div>
                    <div ng-if="vm.PrivilegeService.isCompanyAdmin()" class="row">
                        <span class="label">{{ 'filter.Display anonymized users' | translate }}</span>
                        <div class="items">
                            <label class="switch01">
                                <input name="switch" type="checkbox" ng-model="vm.filter.displayAnonymizedUsers">
                                <span>{{ 'general.Yes' | translate }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </form>
        </div>
    `
})
export default class {
    constructor ($translate, lodash, CLASSIFIER_ENUM, USER_STATUS_ENUM, USER_ACTIVATION_STATUS_ENUM, UserService,
                 ROLE_CODE_ENUM, UserResource, FilterService, PrivilegeService) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.USER_ACTIVATION_STATUS_ENUM = USER_ACTIVATION_STATUS_ENUM;
        this.UserService = UserService;
        this.FilterService = FilterService;
        this.PrivilegeService = PrivilegeService;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.UserResource = UserResource;
    }

    $onInit () {
        this.filters = false;
        this.filterTranslations = this.FilterService.getTranslations();
        this.departments = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);
        this.initMultiFilter();
    }

    queryUsers (input) {
        const params = {
            roleCode: this.ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER,
            'siteIds[]': this.sites.map(site => site.id),
            name: input,
            pageSize: 0
        };
        return this.UserResource.query(params).$promise;
    }

    initMultiFilter () {
        this.FilterService.init(this.classifiers);
        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });
        const siteOptionsSelected = siteOptions.map(site => site);
        const statusOptions = [
            { value: this.USER_STATUS_ENUM.KEYS.ACTIVE, label: this.USER_STATUS_ENUM.LABELS.ACTIVE },
            { value: this.USER_STATUS_ENUM.KEYS.INACTIVE, label: this.USER_STATUS_ENUM.LABELS.INACTIVE },
            { value: this.USER_STATUS_ENUM.KEYS.NOT_STARTED, label: this.USER_STATUS_ENUM.LABELS.NOT_STARTED }
        ];
        const statusOptionsSelected = [statusOptions[0], statusOptions[2]];

        const activationStatusListModel = [];
        const activationStatusListOptions = [
            {
                value: this.USER_ACTIVATION_STATUS_ENUM.KEYS.ACTIVATED,
                label: this.USER_ACTIVATION_STATUS_ENUM.LABELS.ACTIVATED
            },
            {
                value: this.USER_ACTIVATION_STATUS_ENUM.KEYS.EMAIL_SENT,
                label: this.USER_ACTIVATION_STATUS_ENUM.LABELS.EMAIL_SENT
            },
            {
                value: this.USER_ACTIVATION_STATUS_ENUM.KEYS.EMAIL_LINK_INACTIVE,
                label: this.USER_ACTIVATION_STATUS_ENUM.LABELS.EMAIL_LINK_INACTIVE
            },
            {
                value: this.USER_ACTIVATION_STATUS_ENUM.KEYS.NOT_ACTIVATED,
                label: this.USER_ACTIVATION_STATUS_ENUM.LABELS.NOT_ACTIVATED
            }
        ];

        this.multiFilter = {
            statuses: {
                model: statusOptionsSelected,
                options: statusOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            sites: {
                model: siteOptionsSelected,
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            },
            activeStatusList: {
                model: activationStatusListModel,
                options: activationStatusListOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    applyFilter () {
        const siteIds = !this.multiFilter.sites.model.length ? [-1] : this.multiFilter.sites.model.map(site => site.value);
        this.filter = this.lodash.assign(this.filter, { siteIds });
        this.filter = this.lodash.assign(this.filter, { statuses: this.multiFilter.statuses.model.map(status => status.value) });
        this.filter = this.lodash.assign(this.filter, { activationStatusList: this.multiFilter.activeStatusList.model.map(status => status.value) });
        this.filter.roleCode = this.defaultFilter.roleCode;
        if (this.filterDirectManagersOnly) {
            this.filter.roleCode = this.ROLE_CODE_ENUM.KEYS.DIRECT_MANAGER;
        }

        this.filter.departmentIds = this.FilterService.departmentSelect.models
            .filter((department) => department.id !== null)
            .map((department) => department.id);

        this.filter.roleIds = this.FilterService.roleSelect.models
            .filter((role) => role.id !== null)
            .map(role => role.id);

        this.filter.levelIds = this.FilterService.levelSelect.models
            .filter((level) => level.id !== null)
            .map(level => level.id);

        this.list.fetch({ expand: 'drlsWithValue,isValidExternalActivationLink' }, this.filter).then((users) => {
            this.hasActiveUsers = users.filter((user) => this.UserService.isActive(user)).length;
        });
    }

    resetFilter () {
        this.filter = angular.copy(this.defaultFilter);
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.filterDirectManagersOnly = false;
        this.FilterService.initClassifierMultiFilter();
        this.applyFilter();
        this.selectedEmployee = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/filter/index.js